import React, {useState, useEffect} from 'react'
import "./CustomDatatableSuiviTaux.css";
import { useNavigate } from 'react-router-dom';
import { BiEdit } from "react-icons/bi"
import Pagination from '../Pagination/Pagination';
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const CustomDatatableSuiviTaux = (props) => {

    const { columns, 
            data, 
            changePage, 
            pageCount, 
            pageNumber, 
            perPage, } = props;
    const dispatch = useDispatch();


    const navigate = useNavigate();
    let months= ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]


  

  const states = useSelector((state) => state, shallowEqual);

  return (
    <div className="table-responsive ">
                <table className="table table-striped dataTable w-100">
                    <thead className="">
                        <tr role={"row"}>
                            {columns && columns.map((item, index) =>
                                <th key={index+"wcdstc"} style={{"color": "dodgerblue"}} className="suivi-taux-theader text-left pl-5" >
                                    {item.label}</th>
                            )}
                            {/* <th className="text-center w-30">Action</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length != 0 ? data?.map((item, index) =>
                            <tr key={index+"wcdstd"}>

                                <td className="text-left pl-5">{pageNumber > 1 ? (perPage*(pageNumber-1) + (index + 1)) : (index+1)}</td>
                                <td className="text-left pl-5">
                                    {months[parseInt(item.mois) - 1]}
                                </td>
                                <td className="text-left pl-5">
                                    {item.annee}
                                </td>
                                <td className="text-left pl-5">
                                    {item.product}
                                </td>
                                <td className="text-left pl-5">
                                    {item.institution}
                                </td>
                                <td className="text-left pl-5">
                                    {item.category_product}
                                </td>                    
                            </tr>
                        ) : <h1 className="ok"></h1>}
                    </tbody>
                </table>
                <Pagination pageCount={pageCount} changePage={changePage} />
            </div>
  )
}

export default CustomDatatableSuiviTaux